// extracted by mini-css-extract-plugin
export default {"tutor-badges__content":"tutorBadges_tutor-badges__content__pQyWp"};